import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const matrixSynapse = defineConnector({
  identifier: "matrixSynapse",
  name: "Matrix",
  tagLine: "Decentralized communication protocol",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://matrix.org/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Matrix homeserver",
      items: [
        {
          kind: "input",
          label: "Homeserver domain",
          required: true,
          placeholder: "matrix.your-server.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an access token from your Matrix client or via the login API. See the [Client-Server API spec](https://spec.matrix.org/latest/client-server-api/) for details.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) =>
      `https://${domain}/_matrix/client/v3/account/whoami`,
  },
});
